import * as core from '../../../../../../../core'
import * as spaceSurveyStatus from '../space-survey-func-method'

export const RESOURCE = {
  payload: {
    description: 'Manual',
    enumId: core.dms.models.Enum.Id.from({
      partialId: spaceSurveyStatus.RESOURCE.payload.partialId,
    }),
    id: 'MANUAL',
    name: 'Manual',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
